import React, { useState, useEffect, useContext, useRef } from 'react'
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { DataTable } from "..";
import Tick from "../../icons/tick.svg";
import Cross from "../../icons/cross.svg";

import Pending from "../../icons/pending.svg";
import { getAllConsultores, getAllSuppDocs, suppsWithDocs, validateNoDocSuppAlert, validateWithDocSuppAlert } from "../../services";
import {
  daysDiff,
  formatoFechasEs,
} from "../../functions/funciones";
import {
  Box,
  Button,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";
import FiltrosAlertasProv from "../filtros/filtrosAlertasProv";
import { FaCheck } from "react-icons/fa";
//import ModalDocsSupp from "./modalDocsSupp";
import { UsuarioContext } from '../../providers/userContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { construirURLParamsFiltros, useRecogerURLParamsFiltros } from '../../functions/parametrosURL/funcionesParamsURL';

const WithDocumentsAlert = ({ valorTab }) => {
  const { t } = useTranslation('common');

  const user = useContext(UsuarioContext)
  const [Consultores, setConsultores] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [proveedor, setProveedor] = useState({});
  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(false);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [validating, setValidating] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  
  
 
  // const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });


  // useEffect(() => {
  //   getAllConsultores().then((res) => {
  //     setConsultores(res);
  //   });
  // }, []);

  const [primeraCarga, setPrimeraCarga] = useState(true);

  const navigate = useNavigate();
  const refControladorAborto = useRef(null);
  const clearFilters = () => {
    if (user.rol === "CONSUL" && localStorage.getItem("hasReloaded") === "true") {
      setBusqueda({
        ...busqueda,
        consul_id: user.id,
      });
    } else {
      setBusqueda({});
    }

    setClearFilterActivo(true);
}


  const fetchData = async ({ offset, limit, filtros = busqueda, order, orderBy } = {}) => {


    orderBy = orderBy || filtroOrder.ordenadoPor || 'ultimaReclamacion';
    order = order || filtroOrder.orden || 'ASC';

    if (primeraCarga) {
      if (filtros.consul_id === undefined && user.rol === 'CONSUL') {
        filtros.consul_id = user.id
      } else if (filtros.consul_id === 0) {
        delete filtros.consul_id
      }
      setPrimeraCarga(false);
    }

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy, valorTab);

    if (refControladorAborto.current) {
      refControladorAborto.current.abort();
    }
    const nuevoControladorAborto = new AbortController();
    refControladorAborto.current = nuevoControladorAborto;

    const payload = {
      filtros,
      params: { page: offset, limit, order, orderBy },
      signal: nuevoControladorAborto.signal,
    };

    try {
      setLoading(true);
      const response1 = await getAllSuppDocs(payload);
      const { meta, data } = response1;

      if (refControladorAborto.current === nuevoControladorAborto) {
        setProveedores(data);
        setData({
          meta,
          rows: formatData(data),
        });
      }
    } catch (error) {
      if (error?.name === 'AbortError' || error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') {
        if (refControladorAborto.current === nuevoControladorAborto) {
          setLoading(false);
        }
        return;
      }
      console.log(error);
    } finally {
      if (refControladorAborto.current === nuevoControladorAborto) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    return () => {
      if (refControladorAborto.current) {
        refControladorAborto.current.abort();
      }
    };
  }, []);

  const formatData = (data) => {
    return data.map((row, i) => ({
      
      
      proveedor_id: row.id,
      razonSocial: row.razonSocial,
      esCreatedAt: !row.ultimaReclamacion,
      ultimaReclamacion: row.ultimaReclamacion || row.createdAt,
      // ultimaReclamacion: row.ultimaReclamacion || row.createdAt,
      nif: row.nif,
      documentosTrabajadores: row.docTrabajadores,
      planificacionPreventiva: row.docssupps?.find((d) => d.tipoDoc === 4)?.fechaCaducidad || '',
      planificacionPreventivaUR: row.docssupps?.find((d) => d.tipoDoc === 4)?.ultimaReclamacion || '',
      evaluacionRiesgos: row.docssupps?.find((d) => d.tipoDoc === 5)?.validado || '',
      evaluacionRiesgosUR: row.docssupps?.find((d) => d.tipoDoc === 5)?.ultimaReclamacion || '',
      // vigilancia: row.docssupps?.find((d) => d.tipoDoc === 7)?.fechaCaducidad || '',
      // vigilanciaUR: row.docssupps?.find((d) => d.tipoDoc === 7)?.ultimaReclamacion || '',
      rlc: row.docssupps?.find((d) => d.tipoDoc === 9)?.fechaCaducidad || '',
      rlcUR: row.docssupps?.find((d) => d.tipoDoc === 9)?.ultimaReclamacion || '',
      rlcNoProcede: row.docssupps?.find((d) => d.tipoDoc === 9)?.noProcede || false,
      rnt: row.docssupps?.find((d) => d.tipoDoc === 8)?.fechaCaducidad || '',
      rntUR: row.docssupps?.find((d) => d.tipoDoc === 8)?.ultimaReclamacion || '',
      rntNoProcede: row.docssupps?.find((d) => d.tipoDoc === 8)?.noProcede || false,
      listadoTrabajadores: row.docssupps?.find((d) => d.tipoDoc === 10)?.validado || '',
      listadoTrabajadoresUR: row.docssupps?.find((d) => d.tipoDoc === 10)?.ultimaReclamacion || '',
      certificado: row.docssupps?.find((d) => d.tipoDoc === 6)?.fechaCaducidad || '',
      certificadoUR: row.docssupps?.find((d) => d.tipoDoc === 6)?.ultimaReclamacion || '',
      justificante: row.docssupps?.find((d) => d.tipoDoc === 3)?.fechaCaducidad || '',
      justificanteUR: row.docssupps?.find((d) => d.tipoDoc === 3)?.ultimaReclamacion || '',
      seguro: row.docssupps?.find((d) => d.tipoDoc === 2)?.fechaCaducidad || '',
      seguroUR: row.docssupps?.find((d) => d.tipoDoc === 2)?.ultimaReclamacion || '',
      validar: row.id,
      noProcede: row.noProcede
    }));
  };

  const proveedoresRows = [

    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.supplier'),
      overrideFunc: (data, row) => <Link to={"/proveedores/" + row.nif}>{data}</Link>
    },
    {
      id: "ultimaReclamacion",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.lastClaim'),
      // overrideFunc: (data, row) => <span>{isNaN ? formatoFechasEs(data) : "-"}</span>

      overrideFunc: (data, row) => <span style={{color: daysDiff(new Date(data), new Date()) > 30 ? 'red' : 'black'}}>{formatoFechasEs(data)}</span>
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.nif'),
    },
    {
      id: "seguro",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.rc'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap' },
      overrideFunc: (data, row) => (
        data ?
          <Tooltip title={row.seguroUR === '' ? t('suppliers.messages.lastClaim') + ': -' : t('suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.seguroUR)}>
            <span style={{ color: daysDiff(new Date(row?.seguroUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
              {formatoFechasEs(data)}
            </span>
          </Tooltip> : '-'
      )
    },
    {
      id: "justificante",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.preventiveMode'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        row.noProcede ? t('suppliers.columns.notApplicable') :
          data ?
            <Tooltip title={row.justificanteUR === '' ? t('suppliers.messages.lastClaim') + ': -' : t('suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.justificanteUR)}>
              <span style={{ color: daysDiff(new Date(row?.justificanteUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
                {formatoFechasEs(data)}
              </span>
            </Tooltip> : '-'
      )
    },
    {
      id: "evaluacionRiesgos",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.riskEvaluation'),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data, row) => (
        <Tooltip title={row.evaluacionRiesgosUR === '' ? t('suppliers.messages.lastClaim') + ': -' : t('suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.evaluacionRiesgosUR)}>
          <img style={{ width: "20px" }} src={daysDiff(new Date(row?.evaluacionRiesgosUR), new Date()) < 60 ? Pending : !data ? Cross : Tick} alt="vacio" />
        </Tooltip>
      )
    },
    {
      id: "planificacionPreventiva",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.preventivePlanning'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        row.noProcede ? t('suppliers.columns.notApplicable') :
        data ?
          <Tooltip title={row.planificacionPreventivaUR === '' ? t('suppliers.messages.lastClaim') + ': -' : t('suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.planificacionPreventivaUR)}>
            <span style={{ color: daysDiff(new Date(row?.planificacionPreventivaUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
              {formatoFechasEs(data)}
            </span>
            {/* <img style={{ width: "20px" }} src={daysDiff(new Date(row.planificacionPreventivaUR), new Date()) < 60 ? Pending : !data ? Cross : Tick} alt="vacio" /> */}
          </Tooltip> : '-'

      )

    },
    {
      id: "listadoTrabajadores",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.workersList'),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('suppliers.columns.notApplicable') :
          <Tooltip title={row.listadoTrabajadoresUR === '' ? t('suppliers.messages.lastClaim') + ': -' : t('suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.listadoTrabajadoresUR)}>
            <img style={{ width: "20px" }} src={daysDiff(new Date(row?.listadoTrabajadoresUR), new Date()) < 60 ? Pending : !data ? Cross : Tick} alt="vacio" />
          </Tooltip>
      )
    },
    {
      id: "rlc",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.rlc'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('suppliers.columns.notApplicable') :
          data ?
            <Tooltip title={row?.rlcUR === '' ? t('suppliers.messages.lastClaim') + ': -' : t('suppliers.messages.lastClaim') + ": " + formatoFechasEs(row?.rlcUR)}>
              <span style={{ color: daysDiff(new Date(row?.rlcUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
                {formatoFechasEs(data)}
              </span>
            </Tooltip> : '-'
      )
    },
    {
      id: "rnt",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.rnt'),
      noObjeto: true,
      style: { whiteSpace: 'nowrap' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('suppliers.columns.notApplicable') :
          data ?
            <Tooltip title={row?.rntUR === '' ? t('suppliers.messages.lastClaim') + ': -' : t('suppliers.messages.lastClaim') + ": " + formatoFechasEs(row?.rntUR)}>
              <span style={{ color: daysDiff(new Date(row?.rntUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
                {formatoFechasEs(data)}
              </span>
            </Tooltip> : '-'
      )
    },
    {
      id: "certificado",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.socialSecurityCert'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        data ?
          <Tooltip title={row.certificadoUR === '' ? t('suppliers.messages.lastClaim') + ': -' : t('suppliers.messages.lastClaim') + ": " + formatoFechasEs(row.certificadoUR)}>
            <span style={{ color: daysDiff(new Date(row.certificadoUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
              {formatoFechasEs(data)}
            </span>
          </Tooltip> : '-'
      )
    },
    {
      id: "documentosTrabajadores",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.workersDocs'),
      noObjeto: true,
      style: { textAlign: 'center' },
      overrideFunc: (data, row) => (
        row.noProcede ? t('suppliers.columns.notApplicable') :
        <Tooltip title={row.docTrabajadores}>
          <img style={{ width: "20px" }} src={row.docTrabajadores ? Pending : !data ? Cross : Tick} alt="vacio" />
        </Tooltip>
      )
    },
    {
      id: "validar",
      numeric: false,
      disablePadding: false,
      label: t('suppliers.columns.performed'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        // <>
        //   <Button style={{ background: validating ? '#7bc977' : 'green', color: 'white', minWidth: '5px' }} onClick={() => validarSupp(data)} disabled={validating}><FaCheck /></Button>
        // </>
        <>
          <Button style={{ background: validating ? '#7bc977' : 'green', color: 'white', minWidth: '5px' }} onClick={() => validarAllSupp(data)} disabled={validating}><FaCheck /></Button>
        </>
      )
    },
    // {
    //   id: "vigilancia",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Vigilancia salud",
    //   noObjeto: true,
    //   overrideFunc: (data, row) => (
    //     row.noProcede ? 'No procede' :
    //       data ?
    //         <Tooltip title={row?.vigilanciaUR === '' ? 'última reclamación: -' : "última reclamación: " + formatoFechasEs(row?.vigilanciaUR)}>
    //           <span style={{ color: daysDiff(new Date(row?.vigilanciaUR), new Date()) < 60 ? 'orange' : daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black' }}>
    //             {formatoFechasEs(data)}
    //           </span>
    //         </Tooltip> : '-'
    //   )
    // },
  ];

  const handleCallback = () => {
    setRecargar(true)
//     const params = new URLSearchParams(location.search);
//     const pagina = getQueryParam('pagina');
//     const limite = getQueryParam('limite');
//     // Cambiar el parámetro 'pagina' al nuevo valor
//     // params.set('pagina', pagina);
//     // params.set('limite', limite);
// console.log(params.toString())
//     // Navegar a la misma ruta con los nuevos parámetros
//     navigate(`/alertas-proveedores?${params.toString()}`);
  };

  const validarAllSupp = async (id) => {
    try {
      let proveedor = proveedores.find(p => p.id === id)
      const todasRutasVacias = proveedor.docssupps.every(doc => !doc.ruta);
      if(todasRutasVacias){
        validarAlerta(id).then((resultado) => {
          handleCallback(resultado)
        })
      }else{
        validarSupp(id).then((resultado) => {
          handleCallback(resultado)
        })
      }

    } catch (error) {
      console.log(error)
      toast.error(t('suppliers.messages.errorOccurred'));
    }
  }

  const validarSupp = async (id) => {

    // Validar documentos en bloque
    return new Promise(async (resolve, reject) => {
      try {
        const toastInfo = toast.info(t('suppliers.messages.validating'), { autoClose: false });
        let proveedor = proveedores.find(p => p.id === id)
        console.log(proveedor)
        const elementosSeleccionados = proveedor.docssupps.map((d) => d.id)
        console.log(elementosSeleccionados)
        validateWithDocSuppAlert(proveedor.id, elementosSeleccionados).then(() => {
          toast.update(toastInfo, {
            render: t('suppliers.messages.alertValidated'),
            type: toast.TYPE.SUCCESS,
            autoClose: true,
          });
          resolve(true);
        }).catch((error) => {
          console.log(error)
          toast.update(toastInfo, {
            render: t('suppliers.messages.alertValidationError'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
          reject(error)
        })
        setProveedor(proveedor)
      } catch (error) {
        console.log(error)
        toast.error(t('suppliers.messages.errorOccurred'));
        reject(error)
      }
    })

    //Modal para validar documentos individualmente
    
    // let proveedor = proveedores.find(p => p.id === id)
    // setModalEditarOpened(true)  
    //setProveedor(proveedor)
  }
  const validarAlerta = async (id) => {
    setValidating(true);
    try {
      const toastInfo = toast.info(t('suppliers.messages.validating'), { autoClose: false });
      const response = await validateNoDocSuppAlert(id)
      if (response.status === 201) {
        toast.update(toastInfo, {
          render: t('suppliers.messages.alertValidated'),
          type: toast.TYPE.SUCCESS,
          autoClose: true,
        });
        // setRecargar(true)
        setLoading(true);
        fetchData();
      }
      if (response.status === 403) {
        toast.update(toastInfo, {
          render: t('suppliers.messages.alertValidationError'),
          type: toast.TYPE.ERROR,
          autoClose: true,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(t('suppliers.messages.alertValidationErrorShort'));
    } finally {
      setValidating(false);
    }
  }

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros);
    setBusquedaActiva(true);
  }

  return (
    <>
      {/* <ModalDocsSupp
        proveedor={proveedor}
        opened={modalEditarOpened}
        handleClose={() => {
          setModalEditarOpened(false);
          setRecargar(!recargar);
        }}
      /> */}
      <div className="listPage">
        <div className="gridCard">
          <div className="tableContainer">
            <FiltrosAlertasProv onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} />
            <div className="tableWrapper">
              <Box className="pageContent">
                <Box sx={{ mb: 10 }}>
                  <DataTable
                    data={data.rows}
                    isLoading={loading}
                    headers={proveedoresRows}
                    fetcher={fetchData}
                    meta={data.meta}
                    filtros={busqueda}
                    busquedaActiva={busquedaActiva}
                    setBusquedaActiva={setBusquedaActiva}
                    clearFilterActivo={clearFilterActivo}
                    mensaje={t('suppliers.messages.noSuppliers')}
                    segundaCol={true}
                    enumerate={true}
                    recargar={recargar}
                  />
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
      <style jsx="true">{`
        .tableContainer table thead th {
          text-align: center;
        }
      `}</style>
    </>
  );
}

export default WithDocumentsAlert;